import { render, staticRenderFns } from "./RiderCategoryEdit.vue?vue&type=template&id=a805d1ae&lang=pug"
import script from "./RiderCategoryEdit.vue?vue&type=script&lang=js"
export * from "./RiderCategoryEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports